/**
 * The bare host.
 *
 * On the WEB this is not a sign-in address (TECH-3350). An account belongs to
 * one Organisation's pool of Identities and the address chooses the pool
 * (docs/adr/33-identity-homes-sign-in-chosen-by-the-address.md), so a form here
 * would have no pool to sign anybody into. A signed-out visitor is asked for
 * their Organisation instead, and sent to its sign-in address (TECH-3353).
 *
 * On the DESKTOP it is still the login, unchanged and with no tenant. The
 * desktop build has no address of its own — it routes on the hash of a
 * `file://` document — so there is nothing for a label to be part of. Giving it
 * one is out of scope here, and until it has one its login stays as it was.
 */
import { createFileRoute } from "@tanstack/react-router";
import {
	type SignedOut,
	SignInPage,
	validateRedirectSearch,
} from "@/components/auth/sign-in-page";
import { isElectron } from "@/lib/platform";

export const Route = createFileRoute("/")({
	// `?redirect=` because every client sends a signed-out visitor here carrying
	// it, so where they were headed survives the trip through finding their
	// Organisation and signing in.
	validateSearch: validateRedirectSearch,
	component: HomeComponent,
});

const FIND_ORGANISATION: SignedOut = { findOrganisation: true };

const DESKTOP_LOGIN: SignedOut = {
	form: {
		title: "Welcome back",
		description: "Enter your credentials to access your account",
	},
};

function HomeComponent() {
	const { redirect } = Route.useSearch();

	return (
		<SignInPage
			destination={redirect}
			signedOut={isElectron ? DESKTOP_LOGIN : FIND_ORGANISATION}
		/>
	);
}
